import { section } from '@/glow';
import { focusFormStatus } from '@/lib/a11y';

section('newsletter', {
  onLoad() {
    focusFormStatus(this.container);
  },
  onUnload() {},
});
